var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0099CC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.1,473.8c-8.3-3.1-11.5-9.3-11.3-17.9c0.2-9.6,0-19.3,0.1-28.9c0.1-11.5,5.8-17.2,17.3-17.3 c14-0.1,27.9,0,41.9,0c15.5,0,18.9,2.8,21.9,18.6c34.1-14.7,60.4-37.4,77.8-71.3c-7.5,1.7-14.1,3.2-20.7,4.6c-0.6,0.1-1.3,0.3-2,0.4 c-14.9,1.8-24.9-1.5-24.6-21.2c0.6-39.7,0.2-79.5,0.2-119.2c0-14.5,5.5-19.9,20.1-19.3c13.7,0.6,26.4,4.8,38.2,11.8 c1.4,0.8,2.8,1.7,5.5,3.3c-1-46.6-17.8-85-50.9-116.2c-48.1-45.3-124-55.1-182.9-23.8c-59.7,31.7-86,90.7-84.2,139.6 c1.8-1,3.3-1.8,4.8-2.7c12.9-7.6,26.6-12,41.6-12c10.7,0,16.8,5.9,16.8,16.7c0.1,42.2,0.1,84.5,0,126.7c0,11-6,16.7-17.2,16.8 c-42.6,0.3-78.6-34.9-79-77.5c-0.3-24.3-0.4-48.6,0.1-72.8c0.9-44.6,16.2-83.9,45-117.8c30.1-35.4,68.4-57.4,114.2-64.9 C277,19.6,330.3,34.2,376,73.4c38.1,32.7,59.7,74.5,65,124.6c0.1,0.8,0.4,1.6,0.6,2.4c0,34.9,0,69.8,0,104.8 c-1.9,10.1-3,20.4-6,30.2C415.1,403.5,370,446.9,302.2,467c-11.4,3.4-23.4,4.6-35.1,6.8C259.8,473.8,252.5,473.8,245.1,473.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport2);
export default __webpack_public_path__ + "static/media/Support2.1be620c0.svg";
export { ForwardRef as ReactComponent };